{
  "language": {
    "title": "Language",
    "subtitle": "Choose the display language.",
    "saved": "Language saved.",
    "apply": "Apply",
    "applying": "Applying…",
    "incomplete": "Partial translation — anything not yet translated stays in French.",
    "fr": "French",
    "en": "English",
    "fon": "Fon",
    "yo": "Yoruba",
    "bba": "Bariba",
    "partial": "Partial"
  },
  "common": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "retry": "Try again",
    "loading": "Loading…",
    "offline": "Offline",
    "back": "Back",
    "next": "Next",
    "close": "Close",
    "search": "Search",
    "delete": "Delete",
    "edit": "Edit",
    "send": "Send",
    "yes": "Yes",
    "no": "No",
    "queued_one": "{{count}} action waiting to be sent",
    "queued_other": "{{count}} actions waiting to be sent"
  },
  "nav": {
    "home": "Home",
    "request": "Request",
    "help": "Help",
    "account": "Account",
    "dashboard": "Dashboard",
    "offers": "Requests",
    "missions": "Missions",
    "payments": "Payments",
    "clients": "Clients",
    "providers": "Providers",
    "reports": "Reports",
    "services": "Services",
    "vehicles": "Vehicles",
    "subscription": "Subscription",
    "advertising": "Advertising & Visibility",
    "messages": "Messages",
    "details": "Details",
    "dashboardShort": "Dashboard"
  },
  "status": {
    "active": "Active",
    "suspended": "Suspended",
    "pending": "Pending",
    "inProgress": "In progress",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "rejected": "Rejected"
  },
  "service": {
    "transportPerson": "Passenger transport",
    "delivery": "Delivery",
    "equipmentRental": "Equipment rental",
    "driverHire": "Driver hire"
  }
}
